import React, { Component } from 'react';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { CreateTestCycleForm } from '@qality/common-components';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  onClose: (testCycleId: number) => void;
  isAddingTestCases: boolean;
};

export default class CreateTestCycleDialog extends Component<Props> {
  handleSubmit = (testCycleId: number) => {
    StorageOfUniqueServices.get('AP').events.emit('event_testCycle-created');
    this.props.onClose(testCycleId);
  };

  render() {
    return (
      <ModalTransition>
        <Modal
          onClose={this.props.onClose}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEscapePress={true}
          shouldScrollInViewport
        >
          <CreateTestCycleForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onClose}
            isAddingTestCases={this.props.isAddingTestCases}
          />
        </Modal>
      </ModalTransition>
    );
  }
}
